import React, {useEffect} from 'react';
import NewWindow from "react-new-window";
import UploadAnnotator
    from "../../../components/client/application-stages/_common/uploads/v2/uploaded-file/UploadAnnotator";
import useMortgageUploadService from "../useMortgageUploadService";
import useMortgage from "../useMortgage";

export const UploadAnnotatorContext = React.createContext({})

export const useUploadAnnotator = () => {
    const context = React.useContext(UploadAnnotatorContext);
    if (!context) {
        throw new Error('useUploadAnnotator must be used within a UploadAnnotatorProvider');
    }
    return context;
}
function UploadAnnotatorProvider({children}) {
    const {getUploadUrl} = useMortgageUploadService()
    const containerRef = React.useRef({});
    const [state, setState] = React.useState({
        uploadIDs: {}
    });

    const mortgage = useMortgage()

    const sections = mortgage.uploadSections

    const openAnnotator = async (uploadID) => {
        const upload = mortgage.uploads.find(item => item.id === uploadID);
        const url = state.uploadIDs[uploadID]?.url || await getUploadUrl(upload);
        setState(prevState => ({
            ...prevState,
            uploadIDs: {
                ...prevState.uploadIDs,
                [upload.id]: {
                    open: true,
                    url
                }
            }
        }));
    }

    const reloadUrl = async (uploadID)=>{
        const freshUpload = mortgage.uploads.find(item => item.id === uploadID);
        const url = await getUploadUrl(freshUpload);
        setState(prevState => ({
            ...prevState,
            uploadIDs: {
                ...prevState.uploadIDs,
                [uploadID]: {
                    ...prevState.uploadIDs[uploadID],
                    url
                }
            }
        }));

    }

    const closeAnnotator = (uploadId) => {
        setState(prevState => ({
            ...prevState,
            uploadIDs: {
                ...prevState.uploadIDs,
                [uploadId]: {
                    ...prevState.uploadIDs[uploadId],
                    open: false
                }
            }
        }));
    }

   useEffect(()=>{
       return ()=>{
           setState({uploadIDs:[]})
       }
   },[])
    return (
        <UploadAnnotatorContext.Provider value={{openAnnotator, closeAnnotator, reloadUrl}}>
            {children}

            {Object.keys(state.uploadIDs).map(uploadId => {
                const config = state.uploadIDs[uploadId];
                const section = sections.find(s => s.uploads?.find(it => it.id === uploadId));

                return config.open ? ( <NewWindow onUnload={() => setState(s => ({
                    ...s,
                    uploadIDs: {
                        ...s.uploadIDs,
                        [uploadId]: {
                            ...s.uploadIDs[uploadId],
                            open: false
                        }
                    }
                }))}
                    key={`new-win-${uploadId}`}
                     copyStyles={true}
                    features="height=900,width=1200,toolbar=0,location=0,menubar=0"
                     onOpen={(win) => (containerRef.current[uploadId] = win.document.body)}
                >

                    <UploadAnnotator setMortgage={mortgage.setMortgage} containerRef={containerRef.current[uploadId]} uploadID={uploadId} section={section} url={config.url} close={() => closeAnnotator(uploadId)}/>
                </NewWindow>) : null
            })}


        </UploadAnnotatorContext.Provider>
    );
}

export default UploadAnnotatorProvider;